export function isSpecialKey(event) {
  return event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}

$(document).on('input', 'input[type=date]', function resetCustomValidity() {
  // Reset customValidity on input change, otherwise Safari will not fire form submit.
  this.setCustomValidity('');
});

$(document).on('input', 'input[type=checkbox]', function resetCustomValidity() {
  // Reset customValidity on input change, otherwise Safari will not fire form submit.
  document.querySelectorAll(`input[type=checkbox][name="${this.getAttribute('name')}"]`).forEach(input => {
    input.setCustomValidity('');
  });
});
